import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'

import { apiMotor } from '@/lib/api/motor'

export const UserDetailSchema = z.looseObject({
  _id: z.string().optional(),
  id: z.string().optional(),
  name: z.string().default(''),
  email: z.string().default(''),
  profilePicture: z.string().nullish(),
})

export type UserDetailDto = z.infer<typeof UserDetailSchema>

export async function fetchUser(id: string): Promise<UserDetailDto> {
  const res = await apiMotor.get(`/users/${id}`)
  return UserDetailSchema.parse(res.data)
}

export const fetchUserKeys = {
  all: ['fetchUser'] as const,
  details: () => [...fetchUserKeys.all, 'detail'] as const,
  detail: (id: string) => [...fetchUserKeys.details(), id] as const,
}

export function fetchUserOptions(id: string) {
  return queryOptions({
    queryKey: fetchUserKeys.detail(id),
    queryFn: () => fetchUser(id),
    staleTime: 60_000,
  })
}
